// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { InteractiveObject } from "../interactive-object.js";
/**
 * Represents ViewCube interactive object.
 * ViewCube is an auxiliary interactive object displayed at View corner and showing current View orientation.
 * See also [[OccViewer.viewCube]] property.
 */
export class InteractiveViewCube extends InteractiveObject {
    /** Empty constructor. */
    constructor(theViewer, theObjId = "") {
        super(theViewer, theObjId);
        if (theViewer != null) {
            if (this._myObjId === "") {
                this._myObjId = "_InteractiveViewCube";
            }
            theViewer.viewCube.createViewCube(this._myObjId);
        }
    }
    /** Set object visibility state. */
    set visible(theToShow) {
        if (!theToShow) {
            this._myViewer.interactiveContext.eraseObjectList(`${this._myObjId}\n${this.innerMesh}`, false);
        }
        else {
            this._myViewer.interactiveContext.displayObjectList(`${this._myObjId}\n${this.innerMesh}`, false);
        }
    }
    /** Return view cube base size. */
    get baseSize() {
        return this._myViewer.viewCube.getViewCubeBaseSize(this._myObjId);
    }
    /** Set view cube base size. */
    set baseSize(theSize) {
        this._myViewer.viewCube.setViewCubeBaseSize(this._myObjId, theSize);
    }
    /** Get view cube inner mesh. Mesh is drawed inside the view cube. */
    get innerMesh() {
        return this._myViewer.viewCube.getViewCubeInnerMesh(this._myObjId);
    }
    /** Set view cube inner mesh. Mesh is drawed inside the view cube. */
    set innerMesh(theInnerMesh) {
        this._myViewer.viewCube.setViewCubeInnerMesh(this._myObjId, theInnerMesh);
    }
    /** Get labels of view cube. */
    get labels() { return this._myViewer.viewCube.getLabels(this._myObjId); }
    /** Set labels of view cube. */
    set labels(theLabels) {
        this._myViewer.viewCube.setLabels(this._myObjId, theLabels);
    }
    /** Get offset of view cube. */
    get offset() {
        return this._myViewer.viewCube.getViewCubeOffset(this._myObjId);
    }
    /** Set offset of view cube. */
    set offset(theOffset) {
        this._myViewer.viewCube.setViewCubeOffset(this._myObjId, theOffset);
    }
}
